import cx from 'classnames'
import { MdDragIndicator } from 'react-icons/md'

import { Domain } from '../../../igao/shared'
import { Divider } from '../../../shared/Divider'
import { sing } from '../utils'

import ItemEdit from './edit/Item'
import styles from './items.module.scss'

const Item = ({
  provided,
  setEditable,
  itemStyles,
  question,
  editableQuestion,
  setModal,
  controller,
  applyChanges,
  lists,
  handleOnKeyDown,
  setEditableQuestion,
  actionIcon
}) => {
  const positionDiff =
    question.diff?.index?.previous - question.diff?.index?.current || 0

  const mapValues = {
    goal: 'Goal',
    label: 'Question',
    template: 'Issue Template',
    domain: 'Domain'
  }

  return (
    <>
      <button
        ref={provided.innerRef}
        {...provided.draggableProps}
        style={itemStyles}
        onClick={() => setEditable(question)}
      >
        <span
          {...provided.dragHandleProps}
          style={{
            display: 'inline-block',
            position: 'absolute',
            top: 'calc(50%)',
            transform: 'translateY(-50%)',
            left: '-25px',
            color: '#D2CECE'
          }}
        >
          <MdDragIndicator
            width={20}
          />
        </span>
        <div
          className={cx(styles.issueDraggableContainer, {
            [styles.active]: !question.hidden,
            [styles.draft]: question.draft
          })}
        >
          {question.label}
          <div className={styles.rightContainer}>
            <div
              style={{
                alignSelf: 'center',
                marginRight: '15px'
              }}
            >
              {Object.keys(question?.diff || {})?.map(
                val =>
                  mapValues[val] && (
                    <span
                      key={val}
                      className={styles.diffTag}
                    >
                      {mapValues[val]}
                    </span>
                  )
              )}
            </div>
            <div
              style={{
                marginRight: '15px',
                alignSelf: 'center',
                width: '20px',
                color: '#9a9797'
              }}
            >
              {sing(positionDiff)}
            </div>
            <Domain
              domain={question.domain}
              lists={lists}
            />
            {actionIcon(question)}
          </div>
        </div>
      </button>
      <Divider />
      {editableQuestion?.id === question.id && (
        <div className={styles.editQuestionForm}>
          <ItemEdit
            setModal={setModal}
            controller={controller}
            applyChanges={applyChanges}
            question={editableQuestion}
            lists={lists}
            handleOnKeyDown={handleOnKeyDown}
            setEditableQuestion={setEditableQuestion}
          />
        </div>
      )}
    </>
  )
}

export default Item
